import { getObjectUtil } from 'packages/src'
import { REDUX_MODEL_KEY } from '../../../../redux/constants/key'
import { getPathReduxUtil } from '../../../../redux/utils/get-path'
import isNewReduxUtil from '../../../../redux/utils/is-new'
import createPointerAddReduxUtil from '../../../../redux/actions/create/create-pointer'
import setUtil from '../../../../../utils/set'

export default function createAssociationListAddReduxUtil (payload) {
  const {
    stateWrapper,
    association,
    existingInstance,
    isLocal,
    instance,
    dataPath,
    properties,
    associationKey
  } = payload
  const pointers = association.map((assoc, index) => {
    let existingAssociation
    if (existingInstance && isNewReduxUtil(existingInstance)) {
      const existingAssociations = (
        getObjectUtil(
          stateWrapper.state,
          `${getPathReduxUtil(existingInstance)}.${REDUX_MODEL_KEY.CHANGED}.${associationKey}`
        ) || getObjectUtil(
          stateWrapper.state,
          `${getPathReduxUtil(existingInstance)}.${REDUX_MODEL_KEY.DATA}.${associationKey}`
        ) || []
      )
      existingAssociation = existingAssociations[index]
    }

    return createPointerAddReduxUtil(stateWrapper, {
      referencePath: `${getPathReduxUtil(instance)}.${dataPath}`,
      association: assoc,
      properties,
      isLocal,
      existingInstance: existingAssociation
        ? getObjectUtil(stateWrapper.state, getPathReduxUtil(existingAssociation))
        : null
    })
  })
  return setUtil(instance, dataPath, pointers)
}
